import React from 'react';

const CheckboxReverse = () => (
  <svg width="25" height="25" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 0C5.15865 0 0 5.15865 0 11.5C0 17.8414 5.15865 23 11.5 23C17.8414 23 23 17.8414 23 11.5C23 5.15865 17.8414 0 11.5 0Z" fill="white" />
    <path d="M17.3315 9.06314L11.1022 15.2922C10.9153 15.4791 10.67 15.5731 10.4247 15.5731C10.1794 15.5731 9.93408 15.4791 9.7472 15.2922L6.63268 12.1777C6.25786 11.803 6.25786 11.1973 6.63268 10.8226C7.00732 10.4478 7.61288 10.4478 7.9877 10.8226L10.4247 13.2597L15.9764 7.70811C16.3511 7.3333 16.9566 7.3333 17.3315 7.70811C17.7061 8.08276 17.7061 8.68832 17.3315 9.06314Z" fill="#5936E3" />
  </svg>

);

export default CheckboxReverse;
